// For Nuxt 3
import Vue3ColorPicker from "vue3-colorpicker";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Vue3ColorPicker);
});
